"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginManagerBase_1 = require("auto-widget-framework/src/Plugin/PluginManagerBase");
const FormHandlerEvent_1 = require("./FormHandlerEvent");
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
class FormHandlerPluginProvider extends PluginManagerBase_1.default {
    /**
     * Constructs the form handler provider.
     *
     * @param containerAwareFactory
     * @param extensionsProvider
     * @param definitions
     */
    constructor(containerAwareFactory, extensionsProvider, definitions) {
        super(containerAwareFactory, definitions);
        this.extensionsProvider = extensionsProvider;
    }
    /**
     * @inheritDoc
     */
    create(id, ...padArgs) {
        const instance = super.create(id, ...padArgs);
        this.applyExtensions(instance);
        return instance;
    }
    /**
     * Applies extension on a form instance.
     *
     * @param instance
     */
    applyExtensions(instance) {
        let promise = Promise.resolve();
        instance.getDefinition().getExtensions()
            .map((id) => {
            const definition = this.extensionsProvider.getDefinition(id);
            if (!definition) {
                throw new WidgetError_1.default(`Form extensions "${id}" not found for "${instance.getDefinition().getId()}" form handler.`);
            }
            return definition;
        })
            .sort((a, b) => a.getPriority() - b.getPriority())
            .map((definition) => this.extensionsProvider.create(definition.getId()))
            .forEach((extension) => {
            promise = promise.then(() => extension.initialize(instance));
        });
        promise.catch((error) => {
            instance.emit(FormHandlerEvent_1.FormHandlerEvent.ERROR, error);
        });
    }
}
exports.default = FormHandlerPluginProvider;
